import { ref } from 'vue';

import { useColor } from '@composables/use-color';
import { useFontStyle } from '@composables/use-font-style';
import { useSpacing } from '@composables/use-spacing';
import { ColorsType, ColorManagerType } from '@constants/colors';
import { FontStyleType } from '@constants/font-style';
import { SpacingType } from '@constants/spacing';
import { MAX_WIDTHS, MIN_WIDTHS } from '@constants/ui-constants';

type UseStyleType = {
  colors: ColorsType,
  colorManager: ColorManagerType,
  fontStyle: FontStyleType,
  spacing: SpacingType,
}
type UseStyleFunctionType = () => UseStyleType;

export const useStyle: UseStyleFunctionType = () => {
  const { colors, colorManager } = useColor();
  const { fontStyle } = useFontStyle();
  const { spacing } = useSpacing();
  return {
    colors,
    colorManager,
    fontStyle,
    spacing,
  } as UseStyleType;
};

export const useRootContainerStyle = ({
  type = 'PRIMARY',
  extension = {},
}: {
  type?: 'PRIMARY' | 'SECONDARY',
  extension?: object,
} = {}) => ref({
  height: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: MAX_WIDTHS[type],
  minWidth: MIN_WIDTHS[type],
  width: '100%',
  ...extension,
});
